<!-- Navbar -->
<div class="page-wrapper home-page-shell">
<HomeNavBar @toggleMenu="showMenu = !showMenu" @new_report="addReportToHome"
  @new_temp_post="addTemporaryPost" @active-profile-loaded="onActiveProfileLoaded"/>
<!-- Main Content -->
<InactivityModal />
<div class="row fixed-row home-fixed-row">
  <div class="d-none d-xl-block col-lg-3 sidebar-left">
    <div v-if="client_features.show_events">
    <UserEvents ref="user_events" />
    </div>
    <!--Category Sidebar-->


    <div class="col-12 col-md-6 col-lg-12 mb-4 d-none d-md-block mt-2">
  <div class="card bg-transparent border rounded-5 shadow-sm d-none d-xl-block mx-1" v-if="client_features.show_categories">
    <h6 class="text-muted bg-transparent d-flex card-header justify-content-between align-items-center ">
      <span>Filter By Category</span>
      <div class="d-flex align-items-center gap-2">
        <CreateSubject @newSubject="handle_new_subject" />
        <AllSubjects />
      </div>
    </h6>
<div class="mb-4 mt-2 filter-sidebar scrollable-container" v-if="categories.length && client_features.show_tags">
  <div v-for="(category, categoryIndex) in categories" :key="categoryIndex" class="mb-1">

    <!-- Category header -->
    <div
      class="d-flex justify-content-between align-items-center pointer"
      v-if="category.tags && category.tags.length"
      data-bs-toggle="collapse"
      :data-bs-target="`#collapse-category-${category.id}`"
      aria-expanded="true"
      :aria-controls="`collapse-category-${category.id}`"
    >
      <h6 class="fw-semibold ms-2">
        {{ category.name || 'Unknown Category' }}
      </h6>

      <i class="bi bi-chevron-down pointer"></i>
    </div>

    <div v-else class="d-flex justify-content-between align-items-center">
      <h6 class="fw-semibold ms-2">
        {{ category.name || 'Unknown Category' }}
      </h6>
    </div>

    <!-- Tags - Only show if category has tags -->
    <div v-if="category.tags && category.tags.length"
         :id="`collapse-category-${category.id}`"
         class="collapse">
      <div v-for="tag in category.tags" :key="tag.id" class="form-check d-flex align-items-center mb-1">
        <input class="form-check-input checkbox-sm small mx-0 pointer"
               type="checkbox"
               :id="`tag-${tag.id}`"
               :checked="isTagSelected(tag.id)"
               @change="toggleTag(tag.id)" />
        <label class="form-check-label fw-semibold ms-2 text-xxs pointer"
               :for="`tag-${tag.id}`">
          {{ tag.name || 'Unknown Tag' }}
        </label>
      </div>
    </div>
  </div>
</div>

<div class="filter-sidebar scrollable-container" v-else-if="subjects.length  && client_features.show_subjects">
    <div v-for="subject in subjects" :key="subject.id" class="mb-4 mt-2">
      <!-- Subject header -->
      <h6 class="mb-1 text-xxs fw-600 d-flex justify-content-between align-items-center pointer"
          data-bs-toggle="collapse" :data-bs-target="`#collapse-subject-${subject.id}`" aria-expanded="true"
          :aria-controls="`collapse-subject-${subject.id}`">
        {{ subject.name }}
        <i class="bi bi-chevron-down"></i>
      </h6>

      <!-- Subject collapsible -->
      <div :id="`collapse-subject-${subject.id}`" class="collapse ms-2">

        <!-- Group tags by category id -->
       <div v-for="([categoryId, tags]) in Array.from(groupedTagsById(subject.subject_tags))"
     :key="categoryId" class="mb-2">

  <!-- Category header -->
  <div
    class="d-flex justify-content-between align-items-center pointer"
    data-bs-toggle="collapse"
    :data-bs-target="`#collapse-category-${subject.id}-${categoryId}`"
    aria-expanded="true"
    :aria-controls="`collapse-category-${subject.id}-${categoryId}`"
  >
    <div class="form-check d-flex align-items-center mb-1">
      <input class="form-check-input checkbox-sm small mx-0 pointer" type="checkbox"
             :id="`category-${categoryId}-${subject.id}`"
             :checked="isCategorySelected(subject.id, categoryId)"
             @click.stop
             @change="toggleCategory(subject.id, categoryId)" />
      <label class="form-check-label fw-semibold ms-2 text-xxs pointer"
             :for="`category-${categoryId}-${subject.id}`"
             @click.stop>
        {{ tags[0]?.tag?.tag_category?.name || 'Unknown Category' }}
      </label>
    </div>

    <i class="bi bi-chevron-down pointer"></i>
  </div>

  <!-- Tags -->
  <div :id="`collapse-category-${subject.id}-${categoryId}`" class="collapse ms-3">
    <div v-for="tag in tags" :key="tag.tag?.id" class="form-check d-flex align-items-center mb-1">
      <input class="form-check-input checkbox-sm small mx-0 pointer"
             type="checkbox"
             :id="`tag-${tag.tag?.id}`"
             :checked="isTagSelected(tag.tag?.id)"
             @change="toggleTag(tag.tag?.id)" />
      <label class="form-check-label fw-semibold ms-2 text-xxs pointer"
             :for="`tag-${tag.tag?.id}`">
        {{ tag.tag?.name || 'Unknown Tag' }}
      </label>
    </div>
  </div>
</div>


      </div>
    </div>
</div>

<div v-else>
  <p class="text-muted text-center">No Topics found.</p>
</div>

  </div>
    </div>

    <!-- Sidebar FAQ -->
    <Adverts />
  </div>

  <!-- Middle Content -->
<div class="col-md-12 col-lg-6 col-12 scrollable-container home-feed-scroll" ref="scrollContainer" @scroll="handleScroll">
    <div class="d-flex flex-column h-100">

    <!-- Mobile & iPad View: Left & Right Alignment -->
<div class="banner-pills">
  <div class="d-flex d-md-none w-100 text-center"> <!-- ← removed bg-banner-gradient here -->
    <ul
      class="pills-billing-tab nav nav-pills mt-2 w-100 nav-fill gap-2 p-2 p-md-0 mb-2"
      id="pills-billing-tab"
      role="tablist"
    >
     <li class="nav-item flex-fill text-center me-2" role="presentation">
    <button
      class="nav-link w-100 text-center px-3 py-2 rounded-5 text-white"
      :class="{ active: activeTab === 'normal_loans_info' }"
      id="normal_loans_tab"
      data-bs-toggle="pill"
      data-bs-target="#normal_loans_info"
      type="button"
      role="tab"
      aria-controls="normal_loans_info"
      :aria-selected="activeTab === 'normal_loans_info'"
      @click="setActiveTab('normal_loans_info')"
    >
      Your Feed
    </button>
  </li>

      <li class="nav-item flex-fill text-center" role="presentation">
        <button
          class="nav-link w-100 text-center px-3 py-2 rounded-5 bg-banner-gradient text-white" :activeTab="activeTab"
          :class="{ active: activeTab === 'top_loans_info' }"
          id="top_loans_tab"
          data-bs-toggle="pill"
          data-bs-target="#top_loans_info"
          type="button"
          role="tab"
          aria-controls="top_loans_info"
          :aria-selected="activeTab === 'top_loans_info'"
          @click="setActiveTab('top_loans_info')"
        >
          Your Voice
        </button>
      </li>
    </ul>
  </div>
</div>
<div :class="[
    'card rounded-5 banner-card d-none d-md-block mb-2',
    school_domain ? 'banner-color-solid' : 'banner-image-mode'
  ]">
    <div class="card-body border-0 d-flex flex-column justify-content-center align-items-center">
    <h5 class="text-white text-center mb-3">{{$welcomeText}}</h5>
    <div class="w-100 banner-pills">
      <ul class="pills-billing-tab nav nav-pills justify-content-center mb-0" id="pills-billing-tab-md" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link text-xxs fw-500 px-4 active" id="normal_loans_tab_md"
                  data-bs-toggle="pill" data-bs-target="#normal_loans_info" type="button" role="tab"
                  aria-controls="normal_loans_info" aria-selected="true"
                  @click="activeTab = 'normal_loans_info'">
            Your Feed
          </button>
        </li>
        <li  class="nav-item" role="presentation">
          <button class="nav-link text-xxs fw-500 px-4" id="top_loans_tab_md"
                  data-bs-toggle="pill" data-bs-target="#top_loans_info" type="button" role="tab"
                  aria-controls="top_loans_info" aria-selected="false"
                  @click="activeTab = 'top_loans_info'">
            Your Voice
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>


    <div class="post-section full-width-mobile p-2 p-md-0 mt-1">
      <CreateFeed v-if="token_exists  && activeTab === 'normal_loans_info' &&reportsReady" @new_report="addReportToHome"
        @new_temp_post="addTemporaryPost" :active-profile="activeProfile"/>
      <div class="tab-content content full-width-mobile w-100 h-100 " id="pills-tabContent">
        <div class="tab-pane fade show active " id="normal_loans_info" role="tabpanel"
          aria-labelledby="normal_loans_tab">
      <div class="mb-4" v-if="subjects.length && soulcity_domain">

        <button
  class="btn btn-primary rounded btn-sm mb-3 w-100 d-block d-md-none py-2"
  type="button"
  data-bs-toggle="offcanvas"
  data-bs-target="#mobileFilterOffcanvas"
  aria-controls="mobileFilterOffcanvas"
> <i class="bi bi-list me-2"></i> Categories
</button>


        <!-- Offcanvas for Mobile Filter -->
<div
  class="offcanvas offcanvas-start d-block d-md-none mobile-filter-panel border-0 rounded-end-4 shadow-lg"
  tabindex="-1"
  id="mobileFilterOffcanvas"
  aria-labelledby="mobileFilterOffcanvasLabel"
  v-if="subjects.length && soulcity_domain"
>
  <div class="offcanvas-header p-3 mt-5 bg-white border-bottom mb-2">
    <div class="min-w-0">
      <p class="text-uppercase text-primary text-xxs fw-bold mb-1">Filters</p>
      <h6 class="mb-0 fw-bold text-dark" id="mobileFilterOffcanvasLabel">Filter By Category</h6>
    </div>
    <div class="d-flex align-items-center gap-2 ms-auto">
      <div class="d-flex align-items-center gap-1">
        <CreateSubject @newSubject="handle_new_subject" />
        <AllSubjects />
      </div>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
  </div>

  <div class="offcanvas-body p-3 bg-light">


    <div v-for="subject in subjects" :key="subject.id" class="bg-white border rounded-3 overflow-hidden mb-3 shadow-sm">
      <!-- Subject header -->
      <button
        class="w-100 border-0 bg-white text-dark p-3 d-flex align-items-center justify-content-between gap-3 text-start text-xs fw-bold"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="`#collapse-subject-${subject.id}`"
        aria-expanded="true"
        :aria-controls="`collapse-subject-${subject.id}`"
      >
        <span>{{ subject.name }}</span>
        <i class="bi bi-chevron-down"></i>
      </button>

      <!-- Subject collapsible -->
      <div :id="`collapse-subject-${subject.id}`" class="collapse px-3 pb-3">
        <!-- Group tags by category id -->
        <div v-for="([categoryId, tags]) in Array.from(groupedTagsById(subject.subject_tags))"
     :key="categoryId" class="border-top pt-2 mt-2">

  <!-- Category header -->
  <div
    class="d-flex align-items-center justify-content-between gap-3 bg-light rounded-3 p-2 pointer"
    data-bs-toggle="collapse"
    :data-bs-target="`#collapse-category-${subject.id}-${categoryId}`"
    aria-expanded="true"
    :aria-controls="`collapse-category-${subject.id}-${categoryId}`"
  >
    <div class="form-check d-flex align-items-center mb-0 min-w-0">
      <input class="form-check-input checkbox-sm small mx-0 pointer flex-shrink-0" type="checkbox"
             :id="`category-${categoryId}-${subject.id}`"
             :checked="isCategorySelected(subject.id, categoryId)"
             @click.stop
             @change="toggleCategory(subject.id, categoryId)"
             data-bs-dismiss="offcanvas"/>
      <label class="form-check-label fw-semibold ms-2 text-xxs pointer text-truncate"
             :for="`category-${categoryId}-${subject.id}`"
             @click.stop>
        {{ tags[0]?.tag?.tag_category?.name || 'Unknown Category' }}
      </label>
    </div>

    <button
       class="btn btn-light btn-sm rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
       type="button">
       <i class="bi bi-chevron-down"></i>
    </button>
  </div>

  <!-- Tags -->
  <div :id="`collapse-category-${subject.id}-${categoryId}`" class="collapse ps-3 pt-2">
    <div v-for="tag in tags" :key="tag.tag?.id" class="form-check d-flex align-items-center py-1 mb-0">
      <input class="form-check-input checkbox-sm small mx-0 pointer flex-shrink-0"
             type="checkbox"
             :id="`tag-${tag.tag?.id}`"
             :checked="isTagSelected(tag.tag?.id)"
             @change="toggleTag(tag.tag?.id)"
             data-bs-dismiss="offcanvas" />
      <label class="form-check-label fw-semibold ms-2 text-xxs pointer text-truncate"
             :for="`tag-${tag.tag?.id}`">
        {{ tag.tag?.name || 'Unknown Tag' }}
      </label>
    </div>
  </div>
</div>

      </div>
    </div>
  </div>
</div>
      </div>

          <div class="temporary-post posting-loader-card" v-if="temporaryPost" id="temp-post">
            <div class="posting-loader-icon" aria-hidden="true">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
            <div class="posting-loader-content">
              <div class="d-flex align-items-center justify-content-between gap-2">
                <p class="mb-0 fw-bold text-xs">Posting your feed</p>
                <span class="posting-loader-status">Saving</span>
              </div>
              <p class="mb-2 text-muted text-xxs text-truncate">{{ temporaryPost.report_name || 'Feed' }}</p>
              <div class="posting-loader-track" aria-hidden="true">
                <span></span>
              </div>
            </div>
          </div>
          <div v-if="filtered_reports.length === 0 && is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
          </div>

          <div v-else>
            <!-- Scrollable container -->
            <div v-if="filtered_reports.length > 0">

              <div v-for="report in filtered_reports" :key="report.unique_key || report.id" :id="report.is_ad ? 'ad-' + report.id : 'post-' + report.id"
                class="card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded-5 border-0 full-width-mobile shadow report-card">

                <!-- Advertisement Block -->
                <div v-if="report.is_ad" class="p-4 bg-light rounded shadow-sm">
                  <!-- Header Section -->
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <!-- Product Image as Logo -->
                      <img
                        v-if="report.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url"
                        :src="report.base_profile?.company?.base_profile?.profile_files?.[0]?.file?.file_url"
                        class="profile-image rounded-circle object-fit-cover profile-list-avatar pointer flex-shrink-0 profile-list-avatar w-auto border"
                        alt="Company Logo"
                      >
                      <div v-else class="bg-light rounded-circle d-flex align-items-center justify-content-center border profile-list-avatar">
                        <i class="bi bi-building fs-4 text-secondary"></i>
                      </div>

                      <div class="ms-3">
                        <div class="d-flex align-items-center">
                          <span class="fw-bold text-dark me-2">
                            {{ report.base_profile?.company?.company_name || 'Business Name' }}
                          </span>
                          <i class="bi bi-patch-check-fill text-primary small" title="Verified Business"></i>
                          <span class="badge bg-warning text-dark ms-2 align-middle">Ad</span>
                        </div>
                      </div>
                    </div>

                    <!-- Dropdown Options -->
                    <div class="dropdown">
                      <button class="btn btn-link text-muted p-0 text-decoration-none shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-three-dots-vertical fs-5"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end shadow-sm border-0 rounded-3 text-xxs">
                        <li>
                          <a class="dropdown-item d-flex align-items-center py-2 pointer" @click.prevent="hide_ad(report.id, report.base_profile?.id)">
                            <i class="bi bi-eye-slash text-muted me-2"></i> Hide Ad
                          </a>
                        </li>
                        <li>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <!-- Product Content Grid -->
                  <div class="d-flex flex-column">
                    <h5 class="fw-bold text-dark mb-2">{{ report.name|| report.title }}</h5>
                    <p class="text-muted small mb-3 lh-base">{{ report.description }}</p>

                    <!-- Product Image Container -->
                    <div class="position-relative w-100 rounded-4 overflow-hidden bg-light border mb-3">
                      <div
                        v-if="get_product_images(report).length"
                        :id="get_ad_carousel_id(report)"
                        class="carousel slide"
                        data-bs-ride="false"
                      >
                        <div
                          v-if="get_product_images(report).length > 1"
                          class="carousel-indicators mb-0"
                        >
                          <button
                            v-for="(image, imageIndex) in get_product_images(report)"
                            :key="`${get_ad_carousel_id(report)}-indicator-${imageIndex}`"
                            type="button"
                            :data-bs-target="`#${get_ad_carousel_id(report)}`"
                            :data-bs-slide-to="imageIndex"
                            :class="{ active: imageIndex === 0 }"
                            :aria-current="imageIndex === 0 ? 'true' : undefined"
                            :aria-label="`Slide ${imageIndex + 1}`"
                          ></button>
                        </div>

                        <div class="carousel-inner mb-2">
                          <div
                            v-for="(image, imageIndex) in get_product_images(report)"
                            :key="`${get_ad_carousel_id(report)}-image-${imageIndex}`"
                            :class="['carousel-item', { active: imageIndex === 0 }]"
                          >
                            <div class="ratio ratio-16x9">
                              <img
                                :src="image.image_url"
                                class="w-100 h-100 object-fit-cover rounded"
                                :alt="`${report.name || 'Product'} image ${imageIndex + 1}`"
                              >
                            </div>
                          </div>
                        </div>

                        <button
                          v-if="get_product_images(report).length > 1"
                          class="carousel-control-prev"
                          type="button"
                          :data-bs-target="`#${get_ad_carousel_id(report)}`"
                          data-bs-slide="prev"
                        >
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button
                          v-if="get_product_images(report).length > 1"
                          class="carousel-control-next"
                          type="button"
                          :data-bs-target="`#${get_ad_carousel_id(report)}`"
                          data-bs-slide="next"
                        >
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                      </div>

                      <div v-else class="text-center text-muted p-4">
                          <i class="bi bi-image fs-1 opacity-25"></i>
                          <p class="small mb-0 mt-2 fw-500">No image available</p>
                      </div>
                    </div>

                    <!-- Bottom: Price & CTA -->
                    <div  class="d-flex align-items-center justify-content-between pt-2">
                       <div v-if="'attributes' in report">
                          <span class="text-muted text-xxs d-block mb-0 text-uppercase fw-semibold">Starting from</span>
                          <h5 class="fw-bold text-dark mb-0">{{ report.price ? 'R ' + report.price : 'Contact for Price' }}</h5>
                       </div>
                       <div v-else>
                          <span class="text-muted text-xxs d-block mb-0 text-uppercase fw-semibold">ADVERTISEMENT</span>
                          <h5 class="fw-bold text-dark mb-0">Visit Website</h5>
                       </div>

                       <button class="btn btn-sm bg-success text-white d-flex align-items-center gap-1 fw-bold shadow-none text-xxs rounded"
                               @click.prevent="view_product_details(report)">
                          <span>{{get_ads_button_info(report)}}</span>
                          <i class="bi bi-arrow-right ms-2"></i>
                       </button>
                    </div>
                  </div>
                </div>


                <!-- Regular Report Block -->
                <div v-else class="row">
                  <div class="col p-3 pointer" @click="display_comment_modal(report)">
                    <div class="d-flex align-items-start gap-3">
                      <!-- Profile Picture -->
                      <div
                        v-if= "!client_features.show_report_author"
                        class="profile-avatar-wrapper"
                        @click="String(report?.base_profile?.profile_type?.name || report?.base_profile?.profile_type || '').toLowerCase().trim() === 'personal'
                          ? view_profile(report.base_profile?.user)
                          : view_profile(report)"
                      >
                        <img
                          v-if="get_active_profile_picture(report)"
                          :src="get_active_profile_picture(report)"
                          loading="lazy"
                          class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                          alt="Profile Picture"
                        >
                        <i
                          v-else
                          class="bi bi-person-circle fs-4 text-dark pointer"
                        ></i>
                      </div>

                      <div class="flex-grow-1">
                        <div class="d-flex justify-content-between align-items-start">
                          <div class="pe-2">
                            <!-- Name / Company + topic + pin -->
                            <p v-if= "!client_features.show_report_author" class="fw-500 mb-0 lh-base small">
                              <span v-if="report?.base_profile?.user?.is_blocked">
                                Unknown User
                              </span>
                              <span v-else-if="String(report?.base_profile?.profile_type?.name || report?.base_profile?.profile_type || '').toLowerCase().trim() === 'personal'"
                              @click="view_profile(report.base_profile?.user)" >
                                {{ report.base_profile?.user?.first_name }} {{ report.base_profile?.user?.last_name }}
                              </span>
                              <span v-else @click.stop="view_profile(report)">
                                {{ report.base_profile?.company?.company_name || 'Company Name' }}
                              </span>

                           <span
                              v-if="report.topic && report.topic.name"
                              class="badge bg-warning text-dark ms-2 align-middle" >
                              <i class="bx bxs-bulb me-1"></i>{{ report.topic.name }}
                            </span>


                              <span v-if="report.is_pinned" class="ms-2 text-warning align-middle">
                                <i class="bx bxs-pin fs-6"></i>
                              </span>
                              <span v-if="report.is_admin_edited" class="ms-1  align-middle">
                                <small class="text-muted mb-2 text-xxs fst-italic">
                                  <i class="bx bx-edit mb-1"></i> Edited by Admin
                                </small>
                              </span>
                              <span v-else-if="report.is_edited" class="ms-2 align-middle">
                                <small class="text-muted text-xxs fst-italic">
                                  <i class="bx bx-edit me-1"></i> Edited
                                </small>
                              </span>
                            </p>

                            <!-- Date -->
                            <p v-if= "!client_features.show_report_author"  class="text-muted small mb-0 d-flex align-items-center gap-1">
                              <i class="bx bxs-stopwatch"></i>
                              <span class="text-xxs">{{ report.publication_date }}</span>
                            </p>
                          </div>

                          <!-- Three Dots Menu -->
                          <div
                            class="dropstart ms-2"
                            @click.stop
                            v-if="(String(report.base_profile?.user?.id) === String(user_details.user_id) && token_exists) || user_details.user_role === 'admin'"
                          >
                            <a href="" class="text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                              <i class="bi bi-three-dots-vertical"></i>
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end lh-sm" aria-labelledby="dropdownMenuButton">
                              <a
                                v-if="user_details.user_role === 'admin'"
                                class="dropdown-item small fw-bold border-bottom"
                                href=""
                                @click.prevent="togglePinReport(report)"
                              >
                                <i :class="report.is_pinned ? 'bx bx-pin fs-6' : 'bx bxs-pin fs-6'"></i>
                                {{ report.is_pinned ? 'Unpin' : 'Pin' }}
                              </a>
                              <li
                                v-if="(soulcity_domain || dwypd_domain || visible_domain && user_details.user_role === 'admin') || String(report.base_profile?.user?.id) === String(user_details.user_id)"
                              >
                                <a
                                  class="dropdown-item small fw-bold"
                                  href=""
                                  data-bs-toggle="modal"
                                  data-bs-target="#edit_report_modal"
                                  @click="edit_report(report)"
                                  v-if="report.total_comments === 0 && report.total_likes === 0"
                                >
                                  <i class="bx bxs-edit fs-6"></i> Edit
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item small fw-bold d-none" href="" @click.prevent="open_event_modal(report.id)">
                                  <i class="bi bi-calendar-event fs-6"></i> Add Event
                                </a>
                              </li>
                              <li>
                                <a class="dropdown-item small fw-bold" href="" @click.prevent="deleteReport(report.id)">
                                  <i class="bx bxs-trash-alt fs-6"></i> Delete
                                </a>
                              </li>
                            </ul>
                          </div>


                        </div>
                      </div>

                    </div>
                     <div class="d-flex flex-wrap gap-1">
                            <div v-if="dwypd_domain"
                            v-for="category in filteredCategoriesForReport(report)"
                              :key="category.name"
                              class="d-flex mb-1"
                            >
                              <div class="fw-bold text-capitalize me-1">{{ category.name }}:</div>
                              <span
                                v-for="(tag, i) in category.tags"
                                :key="tag.id"
                                class="text-primary text-capitalize me-1"
                              >
                                {{ tag.name }}<span v-if="i < category.tags.length - 1">,</span>
                              </span>
                            </div>
                            <!-- </div> -->
                          </div>


                    <!-- Report Description -->
                    <p class="fw-500 text-xxs mt-2 " v-if="report.name">{{ report.name }}</p>
                    <div class="quill-wrapper">
                      <div
                        v-html="displayedDescription(report)"
                        class="ql-editor quill-content fs-6 lh-lg">
                      </div>


                      <!-- Read More / Read Less Toggle (keep commented if not needed) -->
                      <!--
                      <span
                        v-if="report.description && report.description.length > 0 && !soulcity_domain"
                        class="text-secondary cursor-pointer text-xxs ms-1"
                        @click.stop="toggleDescription(report.id)"
                      >
                        {{ isExpanded(report.id) ? 'Read Less' : 'Read More' }}
                        <i v-if="!isExpanded(report.id)" class="bx bx-down-arrow-circle"></i>
                        <i v-else class="bx bx-up-arrow-circle"></i>
                      </span>
                      -->
                    </div>

                 <!-- Images -->
                   <!-- ✅ IMAGE FILES -->
                      <div v-if="getCarouselImages(report).length" class="report-carousel">
                      <div :id="'carousel-' + report.id" class="carousel slide">
                        <!-- Indicators -->
                        <div v-if="getCarouselImages(report).length>1" class="carousel-indicators">
                          <button
                            v-for="(src, i) in getCarouselImages(report)"
                            :key="'indicator-' + i"
                            type="button"
                            :data-bs-target="'#carousel-' + report.id"
                            :data-bs-slide-to="i"
                            :class="{ active: i === 0 }"
                            :aria-current="i === 0 ? 'true' : undefined"
                            :aria-label="'Slide ' + (i + 1)"
                          ></button>
                        </div>

                        <!-- Carousel Inner -->
                        <div class="carousel-inner mb-2">
                          <div
                            v-for="(src, i) in getCarouselImages(report)"
                            :key="'carousel-img-' + i"
                            :class="['carousel-item', { active: i === 0 }]"
                          >
                            <img :src="src.file.url" alt="Feed Image" class="carousel-img media-item rounded"
                            @click.stop="display_comment_modal(report)" />
                          </div>
                        </div>

                        <!-- Controls -->
                         <div v-if="getCarouselImages(report).length>1">
                        <button
                          class="carousel-control-prev"
                          type="button"
                          :data-bs-target="'#carousel-' + report.id"
                          data-bs-slide="prev"
                          @click.stop
                        >
                          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Previous</span>
                        </button>
                        <button
                          class="carousel-control-next"
                          type="button"
                          :data-bs-target="'#carousel-' + report.id"
                          data-bs-slide="next"
                          @click.stop
                        >
                          <span class="carousel-control-next-icon" aria-hidden="true"></span>
                          <span class="visually-hidden">Next</span>
                        </button>
                        </div>
                      </div>
                    </div>
                <div class="d-flex flex-column" v-if="getNonImageReportFiles(report).length">
                  <div v-for="(fileObj, index) in getNonImageReportFiles(report)" :key="fileObj?.id || fileObj?.file?.id || index" class="mb-3">
                        <!-- AUDIO FILES -->
                          <div class="media-container audio-post mb-1 rounded" @click.stop v-if="fileObj?.file?.url &&
                                (fileObj.file.url.includes('.mp3') ||
                                  fileObj.file.url.includes('.wav'))">
                          <div>
                            <div class="audio-post-name">{{ getFileName(fileObj?.file?.url) }}</div>
                          </div>
                          <audio controls class="audio-post-player">
                            <source :src="fileObj.file.url"
                              :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'" />
                            Your browser does not support the audio element.
                          </audio>
                        </div>

                        <!-- VIDEO FILES -->
                        <div class="media-container video-post mb-3"
                          v-else-if="fileObj?.file?.url && /\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)">
                          <video controls class="media-item rounded-5" @click.stop="display_comment_modal(report)">
                            <source :src="fileObj.file.url" />
                            Your browser does not support the video tag.
                          </video>
                        </div>

                        <!-- DOC FILES (PDF, DOCX, ZIP, ETC.) -->
                      <div v-else
                        class="uploaded-file d-flex align-items-center justify-content-between p-3 mb-2 rounded shadow-sm"
                        @click.stop="open_preview(fileObj)">
                        <!-- File Info -->
                        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
                          <div class="d-flex align-items-center justify-center me-3 flex-shrink-0">
                            <img
                              v-if="fileObj?.file?.url"
                              :src="getFileIcon(fileObj.file.url)"
                              class="file-icon"/>
                          </div>

                          <div class="file-details">
                            <span class="file-name d-block">
                              {{ getFileName(fileObj?.file?.url) }}
                            </span>
                          </div>
                        </div>
                        <!-- Actions -->
                        <div class="d-flex align-items-center gap-3 flex-shrink-0 ms-3">
                          <a
                            :href="fileObj?.file?.url"
                            download
                            :title="getFileName(fileObj?.file?.url)"
                            class="file-action-btn"
                            @click.stop
                          >
                            <i class="bi bi-download"></i>
                          </a>

                          <a
                            @click.stop="toggle_library_save(fileObj)"
                            class="file-action-btn"
                            :title="isInLibrary(fileObj?.file.id) ? 'Remove from Library' : 'Save to Library'"
                          >
                            <i
                              class="bi"
                              :class="isInLibrary(fileObj?.file.id)
                                ? 'bi-bookmark-check-fill text-dark'
                                : 'bi-bookmark text-muted'"
                            ></i>
                          </a>
                        </div>
                      </div>

                      </div>
                    </div>


                    <div v-if="report.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border" @click.stop>

                      <a :href="report.report_link" target="_blank" class="text-decoration-none">
                        <img v-if="report.linkPreview.image" :src="report.linkPreview.image"
                          class="img-fluid rounded" />
                        <div class="fw-bold mt-2">{{ report.linkPreview.title }}</div>
                        <div v-if="!report.linkPreview.image" class="text-muted small">{{ report.linkPreview.description
                          }}</div>
                      </a>
                    </div>
                  <!-- ✅ Event Display -->
                <div v-if="report.event_report && report.event_report.length && report.event_report[0].event.end_date >= currentDate"
                  class="mt-3">
                <div v-for="event in [report.event_report[0].event]" :key="event.id || 'event-report-0'" class="card border rounded-5 shadow-sm mb-4 mt-3"@click.stop
                >
                <div class="card-body">
                <div class="d-flex justify-content-between align-items-start">
                <div class="flex-grow-1 pe-3">
                <div class="d-flex flex-wrap">
                <p class="fw-semibold ms-3">Event  : {{ event.event_name }}</p>

                </div>
                </div>
                </div>
                  <hr class="my-0">
                <div class="row g-4 mb-4">
                <!-- Event Period -->
                <div class="col-12 col-md-4">
                <div class="d-flex gap-3">
                <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                <i class="bi bi-calendar-event fs-5 text-secondary"></i>
                </div>
                <div class="flex-grow-1">
                <div class="text-uppercase text-muted small fw-semibold mb-1">Event Period</div>
                <div class="fw-semibold text-xxs">{{event.start_date }}</div>
                <div class="text-muted text-xxs">{{ event.start_time ? event.start_time : '' }}
                <span v-if="event.end_time"> to {{ event.end_time }}</span>
                </div>
                </div>
                </div>
                </div>

                <div class="col-12 col-md-4">
              <div class="d-flex gap-3">
              <div class="bg-light rounded p-2 d-flex align-items-center justify-content-center">
                <i class="bi bi-geo-alt fs-5 text-secondary"></i>
              </div>
                <div class="flex-grow-1">
              <div class="text-uppercase text-muted text-xxs fw-semibold mb-1">Location</div>
              <div class="fw-semibold text-xxs">{{ event.location || 'Not set' }}</div>
              </div>
                </div>
                </div>
                </div>
                      <!-- Actions -->
                <div class="d-flex justify-content-end align-items-center gap-2 flex-wrap">
                <button v-if="event.is_free"
                  class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs" @click.stop="openModal(event)" >
                <i class="bi bi-check-circle me-1"></i> RSVP
                </button>

                  <button v-else
                     class="btn btn-primary btn-sm rounded px-3 py-1 shadow text-xxs" @click.stop="openModal(event)">
                    <i class="bi bi-ticket-perforated me-1"></i> Buy Ticket
                    </button>
                      <a href="/view_events" class="btn btn-primary btn-sm rounded px-3 py-1 text-xxs" >

                        View Event
                      </a>
                        </div>
                        </div>
                        </div>
                        </div>

                  <div
                    v-if="(client_features.show_report_author) && report && report.authors && report.authors.length"
                    class="d-inline-flex align-items-center flex-wrap gap-1"
                  >
                    <span class="report-authors-label">
                      Authors :
                    </span>
                    <span
                      v-for="(author, index) in report.authors"
                      :key="index"
                      class="report-author-chip rounded d-inline-flex align-items-center gap-1"
                    >

                      <a v-if="author.author_link"
                        :href="author.author_link"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="report-author-link"
                        @click.stop>
                        {{ author.author_name }}
                        <i class="bi bi-box-arrow-up-right"></i>
                      </a>
                      <span v-else>{{ author.author_name }}</span>

                    </span>
                  </div>


                    <!-- Likes and Comments Count -->
                    <div class="text-gray mx-2 mt-1 text-end pointer" @click.stop>
                        <span class="me-2" @click.stop="open_likes_modal(report.likes)" data-bs-toggle="modal"
                          data-bs-target="#likes_modal">
                          {{ report.total_likes }}
                          <img src="@/assets/images/like (1).png" class="mb-2 pointer" width="16" height="16" alt="">
                        </span>
                        <span>{{ report.total_comments }}
                          <img src="@/assets/images/speech-bubble.png" class="pointer" alt="" width="16" height="16">
                        </span>
                    </div>

                    <!-- Action Buttons -->
                    <div
                      class="post-action-bar d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 mb-2"
                      @click.stop>
                      <div class="post-action-item d-flex align-items-center">
                        <!-- Like button -->
                        <span v-if="!likedReports[report.id]" class="post-action-control d-flex align-items-center fw-500 pointer menu-open-button"
                          @click.stop="likeReport(report)">
                          <i class="bi bi-hand-thumbs-up text-black pointer"></i>
                          <span class="post-action-label text-purple text-xxs mx-1">Like</span>
                        </span>

                        <!-- Unlike button -->
                        <span v-else class="post-action-control d-flex align-items-center fw-500 pointer menu-open-button"
                          @click.stop="unlikeReport(report)">
                          <i class="bi bi-hand-thumbs-up-fill text-black pointer text-xs"></i>
                          <span class="post-action-label text-xxs mx-1">Unlike</span>
                        </span>

                      </div>
                      <div :class="`post-action-item post-action-control d-flex align-items-center menu-open-button ${!report.can_comment ? 'comment-disabled' : 'pointer'}`" @click.stop="toggle_comment(report.id)">
                        <i class="bi bi-chat fw-bold pointer text-xs"></i>
                        <span class="post-action-label fw-500 text-xxs mx-1">Comment</span>
                      </div>
                      <div class="post-action-item post-action-control d-flex align-items-center menu-open-button pointer" @click.stop="display_comment_modal(report)">
                        <i class="bi bi-clock-history fw-bold pointer text-xs"></i>
                        <span class="post-action-label fw-500 text-xxs mx-1">Timeline</span>
                      </div>
                      <!-- Share Menu -->
                      <div class="post-action-item post-share-action d-flex align-items-center menu mt-1 bg-white" @click.stop>
                        <input type="checkbox" :id="'menu-open-' + report.id" class="menu-open" name="menu-open" />
                        <label :for="'menu-open-' + report.id" class="post-action-control menu-open-button d-flex align-items-center"
                          @click="boon">
                          <i class="bi bi-share pointer text-xs"></i>
                          <span class="post-action-label fw-500 text-xxs mx-1">Share</span>
                        </label>

                        <!-- Copy Link -->
                        <a
                          href="javascript:void(0)"
                          class="menu-item bg-white shadow-sm"
                          @click.stop="handleCopy(report)"
                        >
                          <i class="bi bi-link fs-4 copy text-primary text-xxs"></i>
                        </a>


                        <!-- Twitter -->
                        <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item bg-white  shadow-sm" @click.stop="closeMenu(report.id)">
                          <i class="bi bi-twitter-x"></i>
                        </a>

                        <!-- LinkedIn -->
                        <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item bg-white  shadow-sm linkedin-share-btn"
                          @click.stop="closeMenu(report.id)">
                          <i class="bi bi-linkedin"></i>
                        </a>

                        <!-- Facebook -->
                        <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item bg-white  shadow-sm facebook-share-btn"
                          @click.stop="closeMenu(report.id)">
                          <i class="bi bi-facebook"></i>
                        </a>

                        <!-- WhatsApp -->
                        <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(report,'report'))"
                          target="_blank" class="menu-item bg-white  shadow-sm whatsapp-share-btn"
                          @click.stop="closeMenu(report.id)">
                          <i class="bi bi-whatsapp"></i>
                        </a>

                        <!-- Copy Toast -->
                       <div aria-live="polite" aria-atomic="true"
                            class="position-fixed top-0 start-50 translate-middle-x p-3"
                            style="z-index: 1080;">
                        <div id="copyToast" class="toast bg-primary border-0 text-white" role="alert"
                          aria-live="assertive" aria-atomic="true">
                          <div class="d-flex">
                            <div class="toast-body"></div>
                            <button type="button" class="btn-close btn-close-white me-2 m-auto"
                              data-bs-dismiss="toast" aria-label="Close"></button>
                          </div>
                        </div>
                      </div>

                      </div>

                    </div>


                    <div class="d-flex align-items-center border rounded mb-3 p-0"
                      v-if="activeCommentReportId === report.id"
                      @click.stop>
                        <div class="comment-avatar-wrapper me-2">
                          <img
                            v-if="get_active_profile_picture(activeProfile)"
                            :src="get_active_profile_picture(activeProfile)"
                            class="comment-avatar mx-2"
                            alt="Profile Picture"
                          >
                          <i
                            v-else
                            class="bi bi-person-circle fs-4 text-dark pointer mx-2"
                          ></i>
                        </div>
                      <input type="text" class="form-control border-0 rounded-5 text-xs" id="comment_text_area"
                        v-model="commentText" placeholder="Write a comment" aria-label="Recipient's username"
                        aria-describedby="button-addon2">
                      <div class="d-flex align-items-center">
                        <button class="btn btn-sm text-xxs" type="button" id="button-addon2"
                          @click.stop="submit_comment(report.id)"><i class="bi bi-send-fill text-black fs-6"></i></button>
                      </div>
                    </div>
                    <!-- Comments Component -->
                    <Comments :comments="report.comments" :report-id="report.id" @add-comment="handleAddComment" :activeProfile="activeProfile"/>

                  </div>
                </div>
              </div>
             <div v-if="is_loading" class="text-center py-3">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 mb-0 text-muted">Loading...</p>
             </div>


          </div>

          <div v-else class="text-center py-3">
            <p class="mt-2 mb-0 text-muted">No reports found.</p>
          </div>


        </div>
      </div>
         <div class="tab-pane fade" id="top_loans_info" role="tabpanel" aria-labelledby="top_loans_tab">
            <SurveyView :active_profile="activeProfile" />
          </div>

    </div>
    </div>

  </div>



</div>

    <!-- Sidebar only visible on large (lg) and up -->
<div class="d-none d-xl-block col-lg-3 col-md-4 col-12 sidebar-right px-3">

  <div class="overflow-auto py-1 full-width-mobile  mb-2">
    <div v-if="vsi_domain">
    <OurWorkCard />
    </div>
    <div  v-if="client_features.show_library"  class="card bg-transparent d-none border rounded-5 d-xl-block">
    <div class="mb-4 mt-3">
      <a href="/library">
          <h6 class="card-header text-muted bg-transparent">Library Saved Documents</h6>
      </a>

      <!-- Loading -->
      <div v-if="load_reports" class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- No documents -->
      <div v-else>
        <div v-if="library_resources && library_resources.length === 0" class="text-center text-muted text-xxs fst-italic mt-2">
          No documents available
        </div>

        <!-- Show up to 3 documents -->
        <div class="px-2 mt-3">
        <div v-for="document in library_resources.slice(0, 3)" :key="document.id"
                class="document-item d-flex justify-content-between align-items-center mb-2" @click="open_preview(document?.report_file)">

          <div class="d-flex align-items-center flex-grow-1">
            <div class="file-icon-box d-flex align-items-center justify-content-center text-white me-3"
              :class="getFileClass(document?.report_file?.file.name)">
              {{ getFileLabel(document?.report_file?.file.name) }}
            </div>
            <div>
              <span class="mb-0 document-name text-xs" :title=" document.report_file.file.name">{{ document.report_file.file.name }}</span>
            </div>
          </div>

          <div class="d-flex me-2 align-items-end justify-content-between">

          <a href="#" class="btn btn-link p-0" @click.prevent="downloadFile(document.report_file.file )">
            <i class="bi bi-download fs-5 text-muted"></i>
          </a>

           <a href="#" class="btn btn-link p-0 ms-2" @click.prevent="delete_document(document.report_file.file.id)">
            <i v-if="document.is_saved" class="bi bi-bookmark-x-fill text-danger fs-5"></i>
            <i v-else class="bi bi-bookmark-check-fill text-dark fs-5"></i>
          </a>
          </div>
        </div>
        </div>
        <!-- Show See More only if there are more than 3 documents -->
        <div v-if="library_resources.length > 3" class="text-center mt-3">
          <router-link to="/library" class="text-decoration-none fs-italic text-xxs">
            See more
          </router-link>
        </div>
      </div>
    </div>

    <div v-if="client_features.show_library"  class="mb-4 mt-3">
       <a href="/view_recent_uploads">
          <h6 class="card-header text-muted bg-transparent">Recently Uploaded</h6>
      </a>

      <!-- Loading -->
      <div v-if="load_reports" class="text-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- No documents -->
   <div v-else>

  <!-- Empty State -->
  <div
    v-if="recent_uploaded.filter(d =>
      d.file.name.toLowerCase().includes('.pdf') ||
      d.file.name.toLowerCase().includes('.doc') ||
      d.file.name.toLowerCase().includes('.docx') ||
      d.file.name.toLowerCase().includes('.xls') ||
      d.file.name.toLowerCase().includes('.xlsx') ||
      d.file.name.toLowerCase().includes('.ppt') ||
      d.file.name.toLowerCase().includes('.pptx') ||
      d.file.name.toLowerCase().includes('.txt') ||
      d.file.name.toLowerCase().includes('.csv')
    ).length === 0"
    class="empty-documents text-center py-4"
  >
    <span>No documents available</span>
  </div>

  <div class="px-2 mt-3">

    <!-- Document Item -->
    <div
      v-for="document in recent_uploaded.filter(d =>(
        d.file.name.toLowerCase().includes('.pdf') ||
        d.file.name.toLowerCase().includes('.doc') ||
        d.file.name.toLowerCase().includes('.docx') ||
        d.file.name.toLowerCase().includes('.xls') ||
        d.file.name.toLowerCase().includes('.xlsx') ||
        d.file.name.toLowerCase().includes('.ppt') ||
        d.file.name.toLowerCase().includes('.pptx') ||
        d.file.name.toLowerCase().includes('.txt') ||
        d.file.name.toLowerCase().includes('.csv')
      ) && !isInLibrary(d.file.id)).slice(0,3)"
      :key="document.id"
      class="document-item d-flex justify-content-between align-items-center mb-2"
    >

      <!-- Left -->
      <div class="d-flex align-items-center flex-grow-1" @click="open_preview(document)">

        <div class="file-icon-box d-flex align-items-center justify-content-center text-white me-3"
          :class="getFileClass(document?.file.name)" >
          {{ getFileLabel(document?.file.name) }}
        </div>

          <span
            class="document-name text-xs"
            :title="document.file.name"
          >
            {{ document.file.name }}
          </span>

      </div>

      <!-- Actions -->
      <div class="document-actions d-flex align-items-center">

        <a
          href="#"
          class="action-btn"
          @click.prevent="downloadFile(document.file)"
        >
          <i class="bi bi-download fw-bold"></i>
        </a>

        <a
          href="#"
          class="action-btn ms-2"
          @click.prevent="toggle_library_save(document)"
        >
          <i
            v-if="isInLibrary(document.file.id)"
            class="bi bi-bookmark-check-fill"
          ></i>
          <i v-else class="bi bi-bookmark"></i>
        </a>

      </div>

    </div>

  </div>

  <div v-if="recent_uploaded.length > 3" class="text-center mt-3">
    <router-link
      to="/view_recent_uploads"
      class="text-decoration-none fs-italic text-xxs">See more
    </router-link>
  </div>

</div>
    </div>
</div>


    <div class="mt-2 mb-2" v-if="client_features.show_upcoming_birthdays">
      <UpcomingBirthdays />
    </div>
    <div class="mb-2" v-if="client_features.show_groups">
      <AllGroups />
    </div>
    <div class="mb-2" v-if="client_features.show_personal_profile">
      <PersonalProfileList />
    </div>
    <div class="mb-2" v-if="client_features.show_business_profile">
      <BusinessList />
    </div>

  <!-- Featured Products Widget -->
  <div class="d-none" v-if="client_features.show_marketplace">
  <div  v-if="products && products.length > 0" class="card border rounded-5 shadow-sm d-flex flex-column border-bottom bg-transparent flex-grow-1 h-100">
    <div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3 pb-0 px-3">
       <h6 class="fw-bold mb-0">Featured Products</h6>
       <span class="badge bg-danger rounded-pill">Hot</span>
    </div>

    <div class="card-body px-2 pb-2">
      <div class="row row-cols-2 g-2">
        <div v-for="product in products.slice(0, 4)" :key="'feat-'+product.id" class="col" @click="view_product_details(product)">
          <div class="card h-100 border shadow-sm pointer featured-product-card-hover">
            <div class="ratio ratio-1x1 bg-light rounded-top overflow-hidden">
               <img
                 :src="product.images && product.images.length ? product.images[0].image_url : ''"
                 class="w-100 h-100 object-cover-fit"
                 alt="Product"
               >
            </div>
            <div class="card-body p-2 d-flex flex-column">
               <div class="fw-semibold small text-truncate text-xxs mb-0" :title="product.name">{{ product.name }}</div>
               <div class="text-xs text-muted mb-0">{{product?.base_profile?.company?.company_name}}</div>
               <div class="small text-xxs mb-2">R {{ product.final_price || product.price || '0.00' }}</div>
               <button class="btn btn-sm btn-primary text-xxs rounded px-3 py-1 shadow">View</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3 pb-1">
        <button class="btn btn-sm btn-primary text-xxs rounded px-3 shadow" @click="$router.push('/marketplace')">
            View All Products
        </button>
      </div>
    </div>
  </div>

  </div>

  </div>
</div>

  </div>

  <div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <h5 class="modal-title text-white" id="exampleModalLabel">Edit your Feed</h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="edit_report_data">

          <div class="modal-body">
            <div  v-if= "!dwypd_domain && !soulcity_domain" class="user-info mb-4">

            <div class="user-avatar">
               <div class="user-avatar">
                <img
                  v-if="!dwypd_domain && !soulcity_domain && get_active_profile_picture(report_edit)"
                  :src="get_active_profile_picture(report_edit)"
                  loading="lazy"
                  class="profile-image rounded-5 profile-list-avatar pointer flex-shrink-0"
                  alt="Profile Picture">
                  <i v-else class="bi bi-person-circle fs-4 text-dark pointer"></i>
              </div>
            </div>
            <div>
              <div v-if="$route.path.includes('profile')" class="user-name mb-0"> {{companyName || profileName}}</div>
                <div v-else-if="!activeProfile?.company?.company_name" class="user-name mb-0">
                  {{activeProfile?.user?.first_name}} {{activeProfile?.user?.last_name}}</div>
                <div v-else class="user-name mb-0">{{activeProfile?.company?.company_name}}</div>
              </div>
            </div>

            <div class="mt-2 m-2 d-flex align-items-center flex-wrap gap-2">
            <span class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="openEditCategoryModal">Tag a category </span>
            <div class="d-flex flex-wrap gap-1">
              <span
                v-for="tag in allSelectedTags"
                :key="tag.id"
                class="btn-sm d-flex align-items-center bg-light border px-3 py-1"
              >
                {{ tag.name }}
              </span>
            </div>


             <span v-if="dwypd_domain || soulcity_domain|| visible_domain" class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" @click="openEditAuthorModal">Edit Author</span>
       <div v-if="dwypd_domain || soulcity_domain || visible_domain  && report_edit && report_edit.authors && report_edit.authors.length"
            class="d-flex flex-wrap gap-2 align-items-center">

        <span v-for="(author, index) in report_edit.authors" :key="index"
            class="btn-sm d-flex align-items-center bg-light border">
          {{ author.author_name }}
          <a v-if="author.link" :href="author.link" target="_blank"
            class="text-white ms-1 text-decoration-underline" @click.stop>
            🔗</a>
            <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove"
            @click="removeAuthor(index)"></button>

        </span>
      </div>

          </div>
            <!-- Select Topic -->
            <div v-if="topics.length > 0" class="m-2 d-flex align-items-center flex-wrap gap-2">
              <label class="form-label text-xxs fw-500">Segment (Topic)</label>
              <select class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1" v-model="selected_topic"
                id="topic">
                <option value="" selected hidden>Tag a segment</option>
                <option v-for="topic in topics" :value="topic.id" :key="topic.id">
                  {{ topic.name }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center mb-3">
              <label for="toggle-comments" class="form-label mb-0 text-xs fw-500">Allow comments:</label>
              <div class="form-check form-switch comment-switch">
                <input class="form-check-input" type="checkbox" id="toggle-comments" v-model="comments_off">
              </div>
              <label class="form-check-label text-xxs" for="toggle-comments">{{ comments_off ? 'Yes' : 'No' }}</label>
            </div>

            <QuillEditor theme="snow" v-model="report_description" ref="quillReportRef" class="quill-editor"
              toolbar="full" />
              <div v-if="report_edit.linkPreview" class="link-preview rounded mt-2 p-2 position-relative border">

                <a :href="report_edit.report_link" target="_blank" class="stretched-link text-decoration-none">
                  <img v-if="report_edit.linkPreview.image" :src="report_edit.linkPreview.image"
                    class="img-fluid rounded" />
                  <div class="fw-bold mt-2">{{ report_edit.linkPreview.title }}</div>
                  <div v-if="!report_edit.linkPreview.image" class="text-muted small">{{ report_edit.linkPreview.description
                    }}</div>
                </a>
              </div>
                 <div class="p-3">
            <div
              class="drop-zone-stable d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 mb-3 text-center transition-all position-relative"
              :class="isDragging ? 'border-primary bg-primary-subtle' : 'border-dashed'"
              @dragover.prevent="isDragging = true" @dragenter.prevent="isDragging = true"
              @dragleave.prevent="isDragging = false" @drop.prevent="handle_drop" @click="$refs.fileInput.click()">
              <div class="d-flex align-items-center justify-content-center gap-2 h-100">
                <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                <span class="fw-bold text-black text-sm">Drag & Drop media here or click</span>
              </div>

              <input type="file" ref="fileInput" class="d-none" multiple @change="handleFileUpload">
            </div>
            <div
              class="add-to-post d-flex align-items-center justify-content-between border rounded bg-white shadow-sm">
              <div class="add-to-post-text fw-bold mb-1">Add to your feed</div>

              <div class="d-flex flex-row align-items-center pe-1">
                <label class="post-option-btn d-flex align-items-center justify-content-center border-0" multiple
                  @change="handleFileUpload" title="Images & Docs">
                  <i class="bi bi-images text-success"></i>
                  <input type="file" ref="fileInputRef" class="file-input d-none" multiple @change="handleFileUpload" />
                </label>

                <label class="post-option-btn d-flex align-items-center justify-content-center mb-0">
                  <i class="bi bi-music-note-beamed text-primary"></i>
                  <input type="file" accept="audio/*" class="d-none" @change="handleAudioUpload" />
                </label>

                <div class="d-flex align-items-center border-start ms-2 ps-2">
                  <button class="post-option-btn d-flex align-items-center justify-content-center border-0"
                    @click="startRecording" v-if="!isRecording">
                    <i class="bi bi-mic-fill text-danger"></i>
                  </button>

                  <button class="post-option-btn d-flex align-items-center justify-content-center border-0 pulse-red"
                    @click="stopRecording" v-if="isRecording">
                    <i class="bi bi-stop-circle-fill text-danger"></i>
                  </button>

                  <span v-if="isRecording" class="text-danger fw-bold text-xs ms-1">{{ formattedTime }}</span>
                </div>
              </div>
            </div>
            
              <div v-if="previews.length" class="d-flex flex-wrap gap-3 mt-3 px-1">
                <div v-for="(preview, index) in previews" :key="index" class="preview-item position-relative mb-2">

                  <img v-if="preview.type === 'image'" :src="preview.src" class="preview-image rounded-3 border" />

                  <div v-else-if="preview.type === 'video'" class="position-relative w-100 h-100">
                    <video class="preview-video rounded border">
                      <source :src="preview.src" />
                    </video>
                    <i
                      class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                  </div>

                  <div v-else
                    class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="preview.name.endsWith('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.doc') || preview.name.endsWith('.docx')"
                      class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="preview.name.endsWith('.xls') || preview.name.endsWith('.xlsx')"
                      class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ preview.name }}</span>
                  </div>

                  <button type="button"
                    class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0  fs-6 px-2 py-0"
                    @click="remove_preview(index)">
                    &times;
                  </button>
                </div>
              </div>

          </div>


            <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
              <div class="row g-3 gap-2">
                <div v-for="(fileObj, index) in edit_documents.report_files" :key="index"
                  class="preview-item position-relative mb-2">

                  <button type="button" class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0  fs-6 px-2 py-0"
                      aria-label="Remove"
                      @click="markFileForRemoval(fileObj.id, index)">
                      &times;
                  </button>
                  <!-- Image -->
                  <img
                    v-if="fileObj.file.url.includes('.jpg') || fileObj.file.url.includes('.png') || fileObj.file.url.includes('.jpeg')"
                    :src="fileObj.file.url" alt="Feed Image" class="preview-image rounded-3 border"
                    :class="{ 'zoomed-in': isZoomed }" ref="image" />

                  <!-- Audio -->
                  <audio v-else-if="fileObj.file.url.includes('.mp3') || fileObj.file.url.includes('.wav')" controls
                    class="w-100 rounded-5">
                    <source :src="fileObj.file.url" type="audio/mp3" />
                    Your browser does not support the audio element.
                  </audio>

                  <!-- Video -->
                  <video v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)" controls class="img-fluid rounded-5 w-100">
                    <source :src="fileObj.file.url" />
                    Your browser does not support the video tag.
                  </video>
                  
                  <div v-else
                    class="preview-item rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-1">
                    <i v-if="fileObj.file.url.includes('.pdf')" class="bi bi-file-earmark-pdf-fill text-danger fs-2"></i>
                    <i v-else-if="fileObj.file.url.includes('.doc') || fileObj.file.url.includes('.docx')"
                      class="bi bi-file-earmark-word-fill text-primary fs-2"></i>
                    <i v-else-if="fileObj.file.url.includes('.xls') || fileObj.file.url.includes('.xlsx')"
                      class="bi bi-file-earmark-excel-fill text-success fs-2"></i>
                    <i v-else class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>

                    <span class="text-xxs text-truncate w-100 px-1">{{ fileObj.file.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
<teleport to="body">
  <div class="modal fade" id="author_modal_edit" tabindex="-1" aria-labelledby="author_modal_edit_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-sm">
        <div class="modal-header">
          <h6 class="modal-title" id="author_modal_edit_label">Edit Authors</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- Inputs for editing/adding authors -->
          <input type="text" class="form-control form-control-sm mb-2 rounded"
            v-model="edit_author_input" placeholder="Enter author name" />

      <input type="url" class="form-control form-control-sm mb-2 rounded"
            v-model="edit_author_link" placeholder="Enter author link (optional)" />

      <button type="button" class="btn btn-primary btn-sm mb-2 rounded"
              @click="addAuthor">
        Add Author
      </button>

          <!-- List of existing authors -->
          <div v-if="edit_authors.length" class="mt-2">
            <div class="d-flex flex-wrap justify-content-start gap-1">
              <span v-for="(author, index) in edit_authors" :key="index" class="btn-sm d-flex align-items-center bg-light border px-3 py-1">
                {{ author.author_name }}
                <button type="button" class="btn-close btn-close-dark btn-sm ms-1" aria-label="Remove" @click="removeAuthor(index)"></button>
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm rounded"
                  @click="saveEditAuthors"
                  data-bs-dismiss="modal"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_report_modal">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</teleport>


<teleport to="body">
  <div class="modal fade" id="category_modal_edit" tabindex="-1" aria-labelledby="category_modal_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 rounded-5 shadow-sm">

        <div class="modal-header">
          <h6 class="modal-title" id="category_modal_label">Select Tags for Category</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">

        <!-- PRIMARY TAG -->
<div class="mb-4">
  <label class="form-label fw-bold mb-1">Primary Tag</label>

  <div v-for="(category, index) in categories" :key="'primary-edit-'+category.id"
       v-show="index < 2 || showAllPrimary" class="col-md-12">
    <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

<multiselect
  :model-value="primary_tags.get(category.id)"
    @update:modelValue="tag => selectPrimaryTag(category.id, tag)"
  :options="category.tags"
  :multiple="false"
  placeholder="Select primary tag"
  track-by="id"
  label="name"
  class="text-xs fw-500 mb-3"
>
  <template #option="{ option }">
    <span class="fw-500 text-xxs">{{ option.name }}</span>
  </template>
  <template #selection="{ values }">
    <span v-if="values" class="badge bg-success">{{ values.name }}</span>
  </template>
</multiselect>

  </div>

  <div v-if="categories.length > 2" class="mt-2">
    <button type="button" class="btn btn-link btn-sm text-decoration-none"
            @click="showAllPrimary = !showAllPrimary">
      {{ showAllPrimary ? 'Show Less' : 'Show More' }}
    </button>
  </div>
</div>


          <!-- SECONDARY TAGS -->
          <div class="mb-4">
            <label class="form-label fw-bold mb-1">Secondary Tags</label>


            <div v-for="(category, index) in categories" :key="'secondary-edit-'+category.id"
                 v-show="index < 2 || showAllSecondary" class="col-md-12">
              <label class="form-label fw-bold mb-1 text-xxs">{{ category.name }}</label>

              <multiselect
                :model-value="selected_tags.get(category.id)"
                @update:modelValue="updateTagSelection(category.id, $event)"
                :options="category.tags"
                :multiple="true"
                :preserve-search="true"
                :close-on-select="false"
                :clear-on-select="false"
                placeholder="Select tags"
                class="text-xs fw-500 mb-3"
                track-by="id"
                label="name"
              >
                <template #option="{ option }">
                  <span class="fw-500 text-xxs">{{ option.name }}</span>
                </template>
                <template #selection="{ values }">
                  <span v-for="(tag, index) in values" :key="index" class="badge bg-primary me-1">
                    {{ tag.name }}
                  </span>
                </template>
              </multiselect>

            </div>

            <div v-if="categories.length > 2" class="mt-2">
              <button type="button" class="btn btn-link btn-sm text-decoration-none"
                      @click="showAllSecondary = !showAllSecondary">
                {{ showAllSecondary ? 'Show Less' : 'Show More' }}
              </button>
            </div>

          </div>

        </div>

        <div class="text-end">
          <button type="button" class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3"
                  @click="submit_tags"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_report_modal"
                  data-bs-dismiss="modal">
            Save
          </button>
        </div>

      </div>
    </div>
  </div>
</teleport>
  <StickyNav :activeTab="activeTab"/>

  <!-- Voice Modal -->




  <!-- Commenting modal -->
  <ReportCommentModal v-if="comment_modal_visible" :report_data="report_data"
    @hide_comment_comment="hide_comment_comment" />


    <teleport to="body">
    <div class="modal fade" id="likes_modal" tabindex="-1" aria-labelledby="likes_modal_label" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content border-0 shadow rounded-3">
          <div class="modal-header bg-primary text-white position-relative">
            <h5 class="modal-title fw-bold" id="likes_modal_label">
              <span class="mt-5">Likes</span>
            </h5>
            <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
          </div>

          <div class="modal-body pt-2">
            <ul class="list-group list-group-flush scrollable-container h-50px">
              <li v-for="user in modal_likes" :key="user.id"
                class="list-group-item d-flex align-items-center px-0 border-bottom">
                <!-- Profile image -->
                <div class="position-relative me-3">
                  <img :src="user?.user?.profile_picture || require('@/assets/images/user.png')"
                    class="rounded-circle border" width="48" height="48" alt="Profile">
                  <!-- Reaction overlay -->
                  <img src="@/assets/images/like (1).png"
                    class="position-absolute bottom-0 end-0 rounded-circle border border-white" width="18" height="18"
                    alt="Reaction">
                </div>

                <!-- Name & mutual friend -->
                <div class="fw-semibold">
                  <span v-if="user?.user?.is_blocked">Unknown User</span>
                  <span v-else @click="view_profile(user?.user)">
                    {{ user?.user.first_name }} {{ user?.user.last_name }}
                  </span>
                </div>
              </li>
            </ul>

            <p v-if="modal_likes.length === 0" class="text-muted text-center mt-3">
              No likes yet.
            </p>
          </div>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade" id="report_event" tabindex="-1" aria-labelledby="event_link_modal_label1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title fw-semibold text-white text-xxs" id="event_link_modal_label1">Add Event to Report</p>
            <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- BODY -->
          <div class="modal-body bg-light">
            <ul class="list-group list-group-flush">
              <li v-for="event in upcoming_events" :key="event.id"
                  @click="selected_event_id = event.id"
                  class="list-group-item d-flex justify-content-between align-items-center cursor-pointer mb-3 rounded shadow"
                  :class="selected_event_id === event.id
                          ? 'bg-banner-gradient border border-success shadow-lg text-white'
                          : 'bg-white'">
                <div class="text-">
                  <span class="fw-bold">{{ event.event_name }}</span><br>
                  <small>
                    <i class="bi bi-calendar-event me-1"></i>
                    {{ event.start_date }} – {{ event.end_date }}
                  </small><br>
                  <small >
                    <i class="bi bi-geo-alt me-1"></i>
                    {{ event.location }}
                  </small>
                </div>
                <span v-if="selected_event_id === event.id" class="badge bg-primary">Selected</span>
              </li>
            </ul>

            <!-- EMPTY STATE -->
            <div v-if="upcoming_events.length === 0" class="text-center py-4">
              <i class="bi bi-calendar-x display-6 text-muted"></i>
              <p class="text-muted mt-2">No upcoming events available.</p>
            </div>
          </div>

          <!-- FOOTER -->
          <div class="modal-footer border-0 bg-white">
            <button type="button" class="btn btn-secondary btn-sm text-xxs rounded" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary fw-semibold btn-sm text-xxs rounded" :disabled="!selected_event_id" @click="link_event_report">
              Add Event
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="body">
  <div class="modal fade" id="eventReportRsvpModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded border-0 shadow-sm">
        <div class="modal-header border-0">
          <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body modal-body-scroll d-flex flex-column align-items-center text-center">

          <img src="@/assets/images/thank-you.png" class="w-150" alt="">
          <h6 class="text-center">Thank you for registering</h6>
          <p class="text-center">Please confirm your RSVP below</p>

          <!-- JOIN LINK FOR ONLINE EVENTS -->
          <div v-if="(selectedEvent.event_type?.name === 'online') && selectedEvent.event_link">
            <a v-if="isEventStarted(selectedEvent).canJoin"
              :class="['btn', 'btn-sm', 'fw-500', 'me-2', 'btn-primary']"
              :href="selectedEvent.event_link">
              Join Event
            </a>
            <p v-else class="text-muted text-sm mt-1">
              {{ isEventStarted(selectedEvent).message }}
            </p>
          </div>

          <!-- RSVP / CANCEL LOGIC -->
          <div v-if="selectedEvent.event_type?.name !== 'online' ">
            <span v-if="!isWithinRSVPPeriod(selectedEvent).isValid" class="d-inline-block">
              <p class="text-danger text-xxs">{{ isWithinRSVPPeriod(selectedEvent).message }}</p>
            </span>

            <button v-else class="gap-3" :class="[
                      'btn',
                      'btn-sm',
                      'fw-500',
                      'me-2',
                      selectedEvent.is_rsvped ? 'btn-warning' : 'btn-primary'
                    ]" @click="handle_rsvp(selectedEvent)">
              {{ selectedEvent.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade" id="event_rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <p class="modal-title text-xxs fw-500" id="exampleModalLabel">RSVP</p>
                  <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <form @submit.prevent="addRsvp">
                  <div class="modal-body modal-body-scroll">
                    <label  for="businessName"> Provide business name</label>
                    <input v-if="cbo_domain"type="text" v-model="businessName" placeholder="Business Name" class="form-control rounded-5 text-xxs">

                    <div v-if="cbo_domain" class="form-group mt-2 mb-3">
                      <label for="firstTimeSelect">Is this your first time attending?</label>
                      <select v-model="isFirstTime" class="form-control rounded-5 text-xxs" id="firstTimeSelect">
                        <option disabled value="">Please select an option</option>
                        <option :value="true">Yes</option>
                        <option :value="false">No</option>
                      </select>
                    </div>
                    <div v-if="cbo_domain" class="form-group mt-2 mb-3">
                      <label for="chapterSelect">Home Chapter</label>
                      <select v-model="chapter" class="form-control rounded-5 text-xxs" id="chapterSelect">
                        <option disabled value="">Please select a chapter</option>
                        <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
                      </select>
                    </div>
                      <!-- Menu Selection -->
                      <div v-for="extra in eventExtras" :key="extra.id" class="form-check mb-2 mt-3">
                          <label class="form-check-label text-xxs" :for="extra.extra.id">{{ extra.extra.name }}</label>
                          <div v-for="item in extra.items" :key="item.item_name" class="d-flex align-items-center gap-2 mb-2">
                            <input class="form-check-input mt-1" type="checkbox"
                                  :name="item.item_name" :id="item.item_name"
                                  v-model="selectedItemId" :value="item.id">
                            <div class="d-flex justify-content-between w-100">
                                <div class="d-inline-flex flex-wrap text-muted">
                                    <strong>{{ item.item_name }}</strong>
                                    <span class="fst-italic ms-1">{{ item.description }}</span>
                                </div>
                                <div v-if="!workbook_domain" class="text-end fst-italic text-primary ms-3">
                                    (R{{ item.price }})
                                </div>
                            </div>
                        </div>
                      </div>
                      <!-- Validation Message -->
                      <p class="text-danger text-xxs">Please select at least one item to RSVP.</p>
                      <!-- Dietary Restrictions -->
                      <div class="mb-4 d-none">
                          <label class="form-label text-xxs fw-500">Additional Restrictions</label>
                          <textarea class="form-control rounded-5 text-xxs" rows="2"
                          placeholder="Please specify any allergies or restrictions"></textarea>
                      </div>
                  </div>

                  <div class="modal-footer">
                      <button type="submit" class="btn btn-primary text-xxs rounded-5" >Submit</button>
                  </div>
              </form>
          </div>
      </div>
  </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade" id="ticket_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content rounded border-0 shadow-sm">

      <!-- HEADER -->
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500">{{ selectedEvent?.event_name }}</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <!-- BODY -->
      <div class="modal-body">

        <!-- Event Info -->
        <div class="text-start mb-3">
          <p class="mb-1 text-muted">
            <i class="bi bi-calendar-event"></i>
            {{ formatDate(selectedEvent?.start_date) }}
          </p>
          <p class="mb-1 text-muted" v-if="selectedEvent?.location">
            <i class="bi bi-geo-alt"></i>
            {{ selectedEvent.location }}
          </p>
          <span class="badge bg-light text-dark border rounded-pill" v-if="!selectedEvent?.is_free">
            Paid Event
          </span>
        </div>

        <!-- Tickets Section -->
        <p class="">Select Tickets</p>
        <div v-for="ticket in event_tickets" :key="ticket.id"
          class="d-flex justify-content-between align-items-center border-0 shadow-sm bg-light p-2 mb-2">

        <!-- Ticket Info -->
        <div class="text-start">
          <div class="fw-500">
            {{ ticket?.ticket?.name }}
           <span v-if="ticket.is_sold_out" class="badge bg-danger ms-2">Sold Out</span>
          </div>
          <div class="text-success fw-bold">
            R{{ ticket?.price }}
          </div>
    <small class="text-muted" v-if="ticket.available_instances > 0">
      Available: {{ ticket.available_instances }}
    </small>
        </div>

        <!-- Counter -->
        <div class="d-inline-flex align-items-center border rounded px-2">
          <button class="btn btn-sm border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.max(0, ticket.quantitySelected - 1)">
            –
          </button>
          <span class="px-3">{{ ticket?.quantitySelected }}</span>
          <button class="btn btn-sm border-0 shadow-0 px-2"
                  @click="ticket.quantitySelected = Math.min(ticket.available_instances, ticket.quantitySelected + 1)">
            +
          </button>
        </div>
      </div>


      </div>

      <!-- FOOTER -->
      <div class="modal-footer d-flex justify-content-between align-items-center border-0">
        <h6 class="fw-bold mb-0">Total: R{{ event_tickets.reduce((sum, t) => sum + (t.quantitySelected * t.price), 0) }}</h6>
        <button class="btn btn-primary rounded btn-sm px-4" @click="process_to_checkout"> Proceed To Checkout</button>
      </div>

          </div>
      </div>
  </div>
  </teleport>

  <teleport to="body">

<div class="modal fade" id="preview_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Preview</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body text-center position-relative">

        <!-- Loader Spinner -->
        <div v-if="loading_preview" class="d-flex justify-content-center align-items-center" width="100%" height="100%">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- PDF Preview -->
        <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
          <iframe :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
        </div>

        <!-- Image Preview -->
        <div v-else-if="preview_type === 'image'">
          <img :src="preview_url" class="img-fluid rounded" @load="on_content_loaded" />
        </div>

        <!-- Video Preview -->
        <div v-else-if="preview_type === 'video'">
          <video controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
            <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
            Your browser does not support the video tag.
          </video>
        </div>

        <!-- Audio Preview -->
        <div v-else-if="preview_type === 'audio'">
          <audio controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
            <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
            Your browser does not support the audio element.
          </audio>
        </div>

        <!-- Office Documents (DOCX, XLSX, PPTX) -->
        <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
          <iframe
            :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
            width="100%"
            height="100%"
            frameborder="0"
            @load="on_content_loaded"
          ></iframe>
        </div>

        <!-- Text Files (TXT, CSV) -->
        <div v-else-if="preview_type === 'text'">
          <iframe :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
        </div>

        <!-- Other / Unsupported Files -->
        <div v-else @load="on_content_loaded">
          <p>Preview not available. You can
            <a :href="preview_url" target="_blank" download>download the file</a> to view it.
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
  </teleport>

  <AICOne />
  <div v-if="client_features.show_faq" class="d-none d-xl-block">
    <!-- Floating Action Button -->
    <button class="btn btn-primary fab-left" @click="goToFaq">
      <i class="bi bi-question-circle"></i>
    </button>
  </div>
</div>
